/*
 * Copyright 2025 Intuition Robotics ltd
 */
// tslint:disable:no-import-side-effect
import "./res/styles/styles.scss";

import {App} from "./app/App";
import {config} from "./config";
import {ConnectivityModule, ErrorHandler_Dispatch, Thunder, ThunderDispatcher, ToastBuilder, ToastModule, XhrHttpModule} from "@intuitionrobotics/thunderstorm/frontend";
import {Frontend_ModulePack_PushPubSub} from "@intuitionrobotics/push-pub-sub/frontend";
import {AccountModule} from "@intuitionrobotics/user-account/frontend";
import {EnvironmentModule} from "@modules/EnvironmentModule";
import {BaseHttpRequest, RequestErrorHandler} from "@intuitionrobotics/thunderstorm";
import {BugReportModule} from "@intuitionrobotics/bug-report/frontend";
import {GoalsConfigModule} from "@modules/GoalsConfigModule";
import {UserPreferencesModule} from "@modules/UserPreferencesModule";
import {AlertsModule} from "@modules/AlertsModule";
import {PatientCohortModule} from "@modules/PatientCohortModule";
import {PatientsDataModule} from "@modules/PatientDataModule";
import {MediaQueryModule} from "@modules/MediaQueryModule";
import {PatientsModule} from "@modules/PatientsModule";
import {UsersModule} from "@modules/UsersModule";
import {DemoDataUtils} from "./demo/Patients_DemoData";
import {CommentsModule} from "@modules/CommentsModule";
import {AppointmentModule} from "@modules/AppointmentModule";
import {AppPermissionsModule} from "@modules/AppPermissionsModule";
import {CookieConsentModule} from "@modules/CookieConsentModule";

export interface OnUnauthenticatedResponse {
    onUnauthenticatedResponse: () => void;
}

XhrHttpModule.addDefaultResponseHandler((request: BaseHttpRequest<any>) => {
    // try {
    //     // @ts-ignore
    //     if (request.xhr?.response)
    //         // @ts-ignore
    //         XhrHttpModule.logDebug(`api call with path ${request.url.replace(request.origin, "")} and executionId ${request.getResponseHeader(
    //             // @ts-ignore
    //             "function-execution-id")} took ${request.getElapsedTime()}`)
    // } catch (e) {
    // }

    if (request.getStatus() !== 401)
        return false;

    new ThunderDispatcher<OnUnauthenticatedResponse, "onUnauthenticatedResponse">("onUnauthenticatedResponse").dispatchUI();
    return true;
});

const modules = [
    AccountModule,
    EnvironmentModule,
    BugReportModule,
    ConnectivityModule,
    CookieConsentModule,
    // This needs to be above the other app data modules
    DemoDataUtils,
    GoalsConfigModule,
    UserPreferencesModule,
    AlertsModule,
    PatientCohortModule,
    PatientsDataModule,
    MediaQueryModule,
    PatientsModule,
    CommentsModule,
    AppPermissionsModule,
    UsersModule,
    AppointmentModule
];

export const ErrorHandler_Log: RequestErrorHandler<any> = (request, resError?) => {
    XhrHttpModule.logError(request.errorMessage || resError?.debugMessage);
};

export const CSErrorHandler_Toast: RequestErrorHandler<any> = (request, resError?) => {
    if (request.errorMessage || resError?.debugMessage)
        ToastModule.toastError("Something went wrong...");
};

ToastModule.setDefaultBuilder(new ToastBuilder().setDuration(10000).setHorizontalPosition("right").setVerticalPosition("bottom"));

new Thunder()
    .setConfig(config)
    .addModules(...Frontend_ModulePack_PushPubSub)
    .addModules(...modules)
    .setMainApp(App)
    .build(() => {
        XhrHttpModule.logInfo(`Env: ${EnvironmentModule.getEnvName()}`);
        XhrHttpModule.setErrorHandlers([CSErrorHandler_Toast, ErrorHandler_Dispatch,
            ErrorHandler_Log]);
    });
